import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import RangeCalculator from './components/RangeCalculator';
import reveal from './utils/reveal';

const heroSectionProps = {
  title: 'Far far away, behind the word mountains...',
  description:
    'A small river named Duden flows by their place and supplies it with the necessary regelialia.\t\t It is a paradisementic country, in which roasted parts of sentences fly into your mouth.',
};

function App() {
  return `
        <div class="main" role="main">
            ${Header()}
            <main>
              ${HeroSection({ ...heroSectionProps })}
            </main>
            ${RangeCalculator({ title: 'Range per Charge' })}
            ${Footer()}
        </div>
    `;
}

// Transition reveal listeners
window.addEventListener('scroll', reveal);
window.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero-section');
  if (hero) {
    hero.classList.add('active');
  }
});

export default App;
